import React from "react";

import {
  checkBox,
  extractPeriods,
  fragmentedFormatter,
  generatePeriodicSchema,
  generateYearlySection,
  getBlueCardAccessor,
  multiTestsSectionFormatter,
  oouCertifyFormatter,
  periodicCertifyFormatter,
  periodicFormatter,
  periodicItemFormatter,
} from "./SchemaHelpers";

const steamGenFormatter = (values) => {
  if (values && Array.isArray(values)) {
    return (
      <span style={{ marginTop: "-20px", display: "flex", gap: "50px", justifyContent: "space-around" }}>
        <span>GEN. #1: {values[0]}</span>
        <span>WORKING PRESSURE: {values[1]}</span>
      </span>
    );
  }
};
export const blueCardRailCarSections = {
  sections: (
    data,
    blueCardSectionLookupsObj,
    selectedPerformedByUser,
    handlePerformedByUserChange,
    handleCertifyClick,
    assetAttributes,
  ) => {
    return [
      {
        heights: { header1: "50px" },
        classes: { header1: "avoid-break-inside-theSection" },
        inlineData: true,
        columns: [
          //   {
          //     title: "Year",
          //     colSpan: 2,
          //     rowSpan: 1,
          //     leftAlign: true,
          //     topAlign: true,
          //     className: "tbl-text-normal",
          //     accessor: "reportYear",
          //     valueOnNextLine: true,
          //   },
          {
            title: "1. Operated by",
            colSpan: 8,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Operated By",
            valueOnNextLine: true,
          },
          {
            title: "RR Code",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Operated By RR Code",
            valueOnNextLine: true,
          },
          {
            title: "2. Owned by",
            colSpan: 6,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Owned By",
            valueOnNextLine: true,
          },
          {
            title: "RR Code",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Owned By RR Code",
            valueOnNextLine: true,
          },
        ],
      },
      {
        heights: { header1: "50px" },
        classes: { header1: "avoid-break-inside-theSection" },
        inlineData: true,
        columns: [
          {
            title: "3. Model No",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Model #",
            valueOnNextLine: true,
          },
          {
            title: "4. Loco No.",
            colSpan: 4,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Loco No",
            valueOnNextLine: true,
          },

          {
            title: "5. Year Built",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Year Built",
            valueOnNextLine: true,
          },
          {
            title: "6. PROPELLED BY",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Propelled By",
            valueOnNextLine: true,
          },
          {
            title: "7. HORSEPOWER",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Horsepower",
            valueOnNextLine: true,
          },
          {
            title: "8. TYPE OF SERVICE",
            colSpan: 4,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Type of Rd Service",
            valueOnNextLine: true,
          },
        ],
      },
      {
        heights: { header1: "50px" },
        classes: { header1: "avoid-break-inside-theSection" },
        inlineData: true,
        columns: [
          {
            title: "9. STEAM GEN.",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Steam Gen",
            valueOnNextLine: true,
          },
          {
            title: "GEN. #1",
            colSpan: 9,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: ["Steam Gen #1", "Working Pressure #1"],
            dontJoinValues: true,
            valueOnNextLine: true,
            isValueOnly: true,
            formatter: steamGenFormatter,
          },
          {
            title: "GEN. #1",
            colSpan: 8,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: ["Steam Gen #2", "Working Pressure #2"],
            dontJoinValues: true,
            isValueOnly: true,

            formatter: steamGenFormatter,
            valueOnNextLine: true,
          },
        ],
      },
      {
        heights: { header1: "50px" },
        classes: { header1: "avoid-break-inside-theSection" },
        inlineData: true,
        columns: [
          {
            title: "MAXIMUM PISTON TRAVEL",
            colSpan: 6,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Maximum Piston Travel",
            valueOnNextLine: true,
          },
          {
            title: "TYPE OF AIR BRAKE",
            colSpan: 7,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "Type of Air Brake",
            valueOnNextLine: true,
          },
          {
            title: "11. Out of use Credit",
            colSpan: 7,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "OutOfUse.outOfUseCredit",
            valueOnNextLine: true,
          },
        ],
      },

      {
        heights: { header1: "50px" },
        classes: { header1: "avoid-break-inside-theSection" },
        inlineData: true,
        columns: [
          {
            title: "12. LAST PERIODIC INSPECTION",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            isTitleOnly: true,
            valueOnNextLine: true,
          },
          {
            title: "DATE",
            colSpan: 8,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            formatter: (val) => multiTestsSectionFormatter(val, selectedPerformedByUser, handlePerformedByUserChange, "periodicPrevDate"),

            dontJoinValues: true,
            accessor: [
              ...getBlueCardAccessor(blueCardSectionLookupsObj.periodic92),
              ...getBlueCardAccessor(blueCardSectionLookupsObj.periodic184),
            ],
            valueOnNextLine: true,
          },
          {
            title: "PLACE",
            colSpan: 9,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            formatter: (val) => multiTestsSectionFormatter(val, selectedPerformedByUser, handlePerformedByUserChange, "periodicPrevPlace"),
            className: "tbl-text-normal",
            dontJoinValues: true,
            accessor: [
              ...getBlueCardAccessor(blueCardSectionLookupsObj.periodic92),
              ...getBlueCardAccessor(blueCardSectionLookupsObj.periodic184),
            ],
            valueOnNextLine: true,
          },
        ],
      },

      {
        heights: { header1: "40px" },
        classes: { header1: "avoid-break-inside-theSection" },
        inlineData: true,
        columns: [
          {
            title: "PERIODIC INSPECTIONS",
            colSpan: 20,
            rowSpan: 1,
            centerAlign: true,
            topAlign: true,
            isTitleOnly: true,
            className: "tbl-text-normal",
            accessor: "periodicinspections",
            valueOnNextLine: true,
          },
        ],
      },

      {
        heights: { header1: "50px" },
        classes: { header1: "avoid-break-inside-theSection" },
        inlineData: true,
        columns: [
          {
            title: "13. DATE MO/DAY/YR",
            colSpan: 2,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            isTitleOnly: true,
          },
          {
            title: "14. PLACE",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            isTitleOnly: true,
          },
          {
            title: "15.* ITEMS",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            isTitleOnly: true,
          },
          {
            title: "16. PERSON CONDUCTING",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            isTitleOnly: true,
          },
          {
            title: "15.* ITEMS",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            isTitleOnly: true,
          },
          {
            title: "16. PERSON CONDUCTING",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            isTitleOnly: true,
          },
          {
            title: "17. CERTIFIED BY",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            isTitleOnly: true,
          },
        ],
      },
      ...generatePeriodicSchema(data, blueCardSectionLookupsObj, handleCertifyClick),
      {
        heights: { header1: "40px" },
        classes: { header1: "avoid-break-inside-theSection" },
        inlineData: true,
        columns: [
          {
            title:
              "15.* ITEM CODE:\t\t [1] BRAKES\t\t [2] RUNNING GEAR\t\t [3] CAB EQUIP\t\t [4] MECH EQUIP\t\t [5] ELECT EQUIP\t\t [6] STEAM GEN\t\t [7] SAFETY APPL",
            colSpan: 20,
            rowSpan: 1,
            topAlign: true,
            className: "tbl-text-normal",
            valueOnNextLine: true,
            isTitleOnly: true,
            leftAlign: true,

            titleFormatter: (val) => {
              if (!val) return null;

              const parts = String(val)
                .split(/\t+|\s{2,}/)
                .map((p) => p.trim())
                .filter(Boolean);

              const label = parts.length ? parts[0] : "";
              const items = parts.slice(1);

              return (
                <div
                  style={{
                    fontSize: "15px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px 40px",
                    alignItems: "center",
                  }}
                >
                  {label ? <span style={{ whiteSpace: "nowrap", marginRight: "8px" }}>{label}</span> : null}

                  {items.map((it, idx) => (
                    <span key={idx} style={{ whiteSpace: "nowrap" }}>
                      {it}
                    </span>
                  ))}
                </div>
              );
            },
          },
        ],
      },
      {
        heights: { header1: "50px" },
        classes: { header1: "avoid-break-inside-theSection" },
        inlineData: true,
        columns: [
          {
            title: "TESTS",
            colSpan: 5,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "tests",
            valueOnNextLine: true,
          },
          {
            title: "18. H & H TEST PRESSURE",
            colSpan: 5,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            valueOnNextLine: true,
            accessor: "Drilled",
            formatter: (value) => {
              return value ? "Drilled" : "";
            },
          },
          {
            title: "19. WAIVER PART - 229",
            colSpan: 5,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            dontJoinValues: true,
            valueOnNextLine: true,
          },
          {
            title: "20. WAIVER -- OTHER",
            colSpan: 5,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            dontJoinValues: true,
            valueOnNextLine: true,
          },
        ],
      },

      {
        heights: { header1: "50px" },
        classes: { header1: "avoid-break-inside-theSection" },
        inlineData: true,
        columns: [
          {
            title: "TYPE",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "type",
            isTitleOnly: true,
          },
          {
            title: "INTERVAL NOT MORE THAN",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "intervalnotmorethan",
            isTitleOnly: true,
          },
          {
            title: "21. PERSON CONDUCTING",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "21personconducting",
            isTitleOnly: true,
          },
          {
            title: "22. TEST DATE/PLACE",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "22testdateplace",
            isTitleOnly: true,
          },
          {
            title: "23. CERTIFIED BY",
            colSpan: 3,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "23certifiedby",
            isTitleOnly: true,
          },
          {
            title: "24. PREVIOUS TEST DATE/PLACE",
            colSpan: 5,
            rowSpan: 1,
            leftAlign: true,
            topAlign: true,
            className: "tbl-text-normal",
            accessor: "24previoustestdateplace",
            isTitleOnly: true,
          },
        ],
      },

      generateYearlySection({
        blueCardSectionLookupsObj: blueCardSectionLookupsObj,
        selectedPerformedByUser: selectedPerformedByUser,
        handlePerformedByUserChange: handlePerformedByUserChange,
        handleCertifyClick: handleCertifyClick,
        sectionTitle: "METER",
        frequencyLabel: "368 CALENDER DAYS",
        blueCardKey: "annualTests",
      }),

      generateYearlySection({
        blueCardSectionLookupsObj: blueCardSectionLookupsObj,
        selectedPerformedByUser: selectedPerformedByUser,
        handlePerformedByUserChange: handlePerformedByUserChange,
        handleCertifyClick: handleCertifyClick,
        sectionTitle: "HAMMER & HYDRO",
        frequencyLabel: "736 CALENDER DAYS",
        blueCardKey: "hammerAndHydro",
        drilled: assetAttributes.Drilled,
      }),

      generateYearlySection({
        blueCardSectionLookupsObj: blueCardSectionLookupsObj,
        selectedPerformedByUser: selectedPerformedByUser,
        handlePerformedByUserChange: handlePerformedByUserChange,
        handleCertifyClick: handleCertifyClick,
        sectionTitle: "AIRBRAKE 229.27",
        frequencyLabel: "368 CALENDER DAYS",
        blueCardKey: "airBrakeLevel1",
      }),
      generateYearlySection({
        blueCardSectionLookupsObj: blueCardSectionLookupsObj,
        selectedPerformedByUser: selectedPerformedByUser,
        handlePerformedByUserChange: handlePerformedByUserChange,
        handleCertifyClick: handleCertifyClick,
        sectionTitle: "AIRBRAKE 238.309",
        frequencyLabel: "NUMBER OF CALENDER DAYS",
        blueCardKey: "airBrakeLevel2",
        showDaysColumn: true,
        fragmented: false,
      }),
    ];
  },
};



// WEBPACK FOOTER //
// ./src/components/BlueCardReport/BlueCardReportView/SchemaRailCar.jsx